export default invoiceSituationTimeline

/** @ngInject */
function invoiceSituationTimeline($timeout, DeviceChecker) {
    return ({
        restrict: 'E',
        scope: {
            situations: '=',
            selectedSituation: '=',
            onSituationSelected: '&',
        },
        template: require('./invoiceSituationTimeline.jade')(),
        link($scope, element) {
            $scope.payStatus = { SUCCESS: 'SUCCESS', FAIL: 'FAIL', PENDING: 'PENDING' }
            $scope.position = $scope.situations.indexOf($scope.selectedSituation)
            $scope.selectSituation = (situation) => $scope.onSituationSelected({ situation })

            const scrollTimeline = function (position) {
                const $timeline = element.find('.timeline')
                const $timelineOld = element.find('.timeline-item.timeline-item-timetable.timeline-item-timetable-old')
                const movePosition = $timelineOld.outerWidth() * (position)
                return $timeline.animate({ scrollLeft: movePosition }, 200, 'linear')
            }

            $scope.canMoveToLeft = () => $scope.position > 0

            $scope.canMoveToRight = () => $scope.position < ($scope.situations.length - 1)

            $scope.scroll = function (direction) {
                if (!DeviceChecker.isMobile()) {
                    const canMoveToLeft = (direction === 'LEFT') && $scope.canMoveToLeft()
                    const canMoveToRight = (direction === 'RIGHT') && $scope.canMoveToRight()
                    if (canMoveToLeft || canMoveToRight) {
                        $scope.position = direction === 'LEFT' ? $scope.position - 1 : $scope.position + 1
                        scrollTimeline($scope.position)
                    }
                }

                return true
            }

            $scope.scrollToActive = function () {
                if (!DeviceChecker.isMobile()) {
                    $scope.position = $scope.situations.indexOf($scope.selectedSituation)
                    scrollTimeline($scope.position)
                }
                return true
            }

            return $scope.$watch('selectedSituation', () => $timeout($scope.scrollToActive))
        },
    })
}



// WEBPACK FOOTER //
// ./src/states/invoice/component/invoiceSituationTimeline.js